interface SchoolAILogoSquareProps {
  className?: string
}

export function SchoolAILogoSquare({
  className = 'w-8 h-8',
}: SchoolAILogoSquareProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 276 340"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M217.122 117.817C249.638 117.817 275.998 91.4908 275.998 59.0162C275.998 26.5415 249.638 0.215576 217.122 0.215576C184.606 0.215576 158.246 26.5415 158.246 59.0162C158.246 91.4908 184.606 117.817 217.122 117.817Z"
        fill="#2869DD"
      />
      <path
        d="M180.292 134.817L152.296 127.293C106.813 115.031 95.745 102.212 95.745 83.634C95.745 66.1703 106.999 51.6792 131.461 51.6792H132.205C146.343 51.6792 157.876 40.1606 157.876 26.041C157.876 11.9214 146.343 1.0531 132.205 0.402852C45.7051 -3.68439 5.3384 33.0079 5.3384 95.8957C5.3384 147.729 36.218 173.368 96.3031 190.181L123.741 197.705C171.549 211.082 184.384 221.578 184.384 244.894C184.384 265.238 170.433 278.707 144.204 278.707C117.975 278.707 98.7213 269.418 83.0025 254.276C72.4923 244.337 63.1912 231.611 54.4482 217.584C46.2632 203.65 39.2874 197.798 26.4519 197.798C11.2911 197.798 -1.54441 208.295 0.222799 229.846C1.99001 244.43 3.75721 255.484 6.08249 269.975C7.84969 285.116 9.6169 296.171 12.5002 314.842C14.8255 330.541 23.0105 339.272 36.9621 339.272C49.7976 339.272 57.9826 332.863 60.8659 323.574C63.1912 314.842 67.2837 313.077 73.1433 313.077C77.7939 313.077 83.0955 314.842 89.4202 317.164C104.023 322.366 124.95 331.098 160.574 331.098C231.076 331.098 276 289.761 276 232.725C276 175.69 245.679 152.374 180.385 134.91L180.292 134.817Z"
        fill="#2869DD"
      />
    </svg>
  )
}
